<template>
	<div id="onboardingOptions" class="container-fluid mt-2">
		<Breadcrumb :back="'/kpi'" />
		<div class="row">
			<div class="col-md-3"></div>
			<div class="col-md-6 mt-5">
				<div class="card">
					<div class="card-body">
						<h4>Outstanding Invoices</h4>
						<StatsBarChart v-if="!loading" :data="freshbooksBarChart" :height="200" class="mb-4" />
					</div>
				</div>
			</div>
		</div>

		<div class="row my-5">
			<div class="col-md-3">
				<div class="card">
					<div class="card-body">
						<h4 class="text-center">Overdue 15 - 30 days</h4>
						<div>
							<h6 class="text-center text-danger">{{ overdueInvoices.overdue1530.length }}</h6>
							<p v-for="inv1530 in overdueInvoices.overdue1530" :key="inv1530.id">
								{{ inv1530.organization }}
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<div class="card">
					<div class="card-body">
						<h4 class="text-center">Overdue 30 - 60 days</h4>
						<div>
							<h6 class="text-center text-danger">{{ overdueInvoices.overdue3060.length }}</h6>
							<p v-for="inv3060 in overdueInvoices.overdue3060" :key="inv3060.id">
								{{ inv3060.organization }}
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<div class="card">
					<div class="card-body">
						<h4 class="text-center">Overdue 60 - 90 days</h4>
						<div>
							<h6 class="text-center text-danger">{{ overdueInvoices.overdue6090.length }}</h6>
							<p v-for="inv6090 in overdueInvoices.overdue6090" :key="inv6090.id">
								{{ inv6090.organization }}
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<div class="card">
					<div class="card-body">
						<h4 class="text-center">Overdue 90+ days</h4>
						<div>
							<h6 class="text-center text-danger">{{ overdueInvoices.overdue90.length }}</h6>
							<p v-for="inv90 in overdueInvoices.overdue90" :key="inv90.id">
								{{ inv90.organization }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import restApi from '../../api/index'
import Breadcrumb from '../../components/onboarding/breadcrumb/Breadcrumb.vue'
import StatsBarChart from '@/components/charts/StatsBarChart'

export default {
	name: 'KpiPayments',
	data() {
		return {
			loading: false,
			accountReceivable: [],
			freshbooksBarChart: {
				labels: ['Total ($)', 'Overdue ($)', 'Outstanding ($)'],
				datasets: [
					{
						barThickness: 30,
						label: 'Outstanding',
						backgroundColor: '#ff6384',
						borderColor: '#5e81f4',
						data: [0, 0, 0],
					},
				],
			},
			overdueInvoices: [],
		}
	},
	components: { Breadcrumb, StatsBarChart },
	computed: {
		...mapState(['authUser']),
		...mapGetters(['isAuth']),
	},
	mounted() {},
	created() {
		this.getAcountsReceivable()
	},
	methods: {
		// Programming
		getOnboartingTypes() {
			restApi
				.get('/onboarding-type')
				.then(({ data }) => {
					this.onboardingTypes = data
				})
				.catch(error => {
					console.log(error)
				})
		},

		getAcountsReceivable() {
			restApi
				.get('/kpi/accounts-receivable')
				.then(({ data }) => {
					this.accountReceivable.push(data.total_unpaid)
					this.accountReceivable.push(data.overdue_invoices)
					this.accountReceivable.push(data.outstanding_invoices)
					this.freshbooksBarChart.datasets[0].data = this.accountReceivable
					this.overdueInvoices = data.overdueInvoices
				})
				.catch(error => {
					console.log(error)
				})
		},
	},
	watch: {},
}
</script>
